import { useUnit } from 'effector-react';
import { $global } from 'models/store-global';
import { useRef } from 'react';

import './DiagramsViewerModal.scss';

import CommunityTab from 'components/StyledTemplates/CommunityTab';
import PopUpWrapper from 'components/StyledTemplates/PopUpWrapper';
import OrigSpouseTabs from 'components/pages/Dashboard/common/OrigSpouseTabs';

import { API_URL } from 'utils/api-helper';
import { lazyWithRetry } from 'utils/lazy-with-retry';

import useModal from 'hooks/useModal';
import useResources from 'hooks/useResources';

import { Document } from 'types/zod/document';

const PdfViewer = lazyWithRetry(() => import('components/PdfViewer/PdfViewer'));

const DiagramsViewerModal = () => {
    const { state } = useModal('DIAGRAMS_VIEWER');

    const community = useUnit($global.map((state) => state.community));
    const { docs: documents = [] } = community || {};

    const selectedParticipant = useUnit(
        $global.map((state) =>
            state?.community?.realm?.find((p) => p.participant_id === state.temp?.selected_community_participant),
        ),
    );

    const diagramForSelectedParticipant = (documents || []).find(
        (document: Document) =>
            document?.ownership?.includes?.(selectedParticipant?.participant_id || -1) &&
            ['Diagram', 'Diagram_Spouse'].includes(document.document_type_code),
    );

    const ref = useRef(null);

    const { t } = useResources();

    const url = `${API_URL}/documents/${diagramForSelectedParticipant?.document_id}/pdf-with-name`;

    return (
        <PopUpWrapper name="DIAGRAMS_VIEWER" className="diagrams-viewer-dialog" whiteCross={true} size="xl">
            <CommunityTab
                title={t('newDashboardPage.completePage.diagramsViewer.header')}
                closable={false}
                extra="width: 100%"
                extraBody="padding: 0 !important;"
            >
                <OrigSpouseTabs />
                <div className="diagrams-viewer-modal" ref={ref}>
                    <div className="diagrams-viewer">
                        {!!diagramForSelectedParticipant && <PdfViewer url={url} containerRef={ref} />}
                        {!diagramForSelectedParticipant && <>No diagram available</>}
                    </div>
                </div>
            </CommunityTab>
        </PopUpWrapper>
    );
};

export default DiagramsViewerModal;
